class SizeGuideTabs extends HTMLElement {
  connectedCallback() {
    this.initializeFrame = requestAnimationFrame(() => this.initialize());
  }

  initialize() {
    if (!this.isConnected || this.initialized) return;

    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    const scope = this.closest('.size-guide-drawer__content') || document;
    this.panels = [1, 2, 3]
      .map((index) => scope.querySelector(`[data-size-guide-panel="${index}"]`)?.closest('.shopify-section'))
      .filter(Boolean);

    if (this.buttons.length !== this.panels.length) return;
    this.initialized = true;

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.select(index));
      button.addEventListener('keydown', (event) => this.handleKeydown(event, index));
    });

    this.panels.forEach((panel, index) => {
      this.buttons[index].setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', this.buttons[index].id || this.createButtonId(this.buttons[index], index));
    });

    this.handleSectionSelect = (event) => {
      const selectedIndex = this.panels.findIndex((panel) => panel.id.endsWith(event.detail.sectionId));
      if (selectedIndex >= 0) this.select(selectedIndex);
    };
    document.addEventListener('shopify:section:select', this.handleSectionSelect);

    this.select(0, false);
  }

  disconnectedCallback() {
    if (this.initializeFrame) cancelAnimationFrame(this.initializeFrame);
    if (this.handleSectionSelect) {
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
    }
    this.initialized = false;
  }

  createButtonId(button, index) {
    const id = `SizeGuideTab-${index + 1}`;
    button.id = id;
    return id;
  }

  select(activeIndex, focus = false) {
    this.buttons.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.tabIndex = isActive ? 0 : -1;
      this.panels[index].hidden = !isActive;
    });

    if (focus) this.buttons[activeIndex].focus();
  }

  handleKeydown(event, currentIndex) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();

    let nextIndex = currentIndex;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.buttons.length - 1;
    this.select(nextIndex, true);
  }
}

if (!customElements.get('size-guide-tabs')) {
  customElements.define('size-guide-tabs', SizeGuideTabs);
}
